/**
 * BACKYARD WELDING PLANS™ — purchase configuration.
 *
 * CHECKOUT_URL is the single destination used by every purchase button
 * (offer CTA, final CTA and mobile sticky bar).
 */
export const CHECKOUT_URL = 'https://backyard-welding-plans.impultienda.ar/checkout'

export const PRICE = {
  value: 37,
  currency: 'USD',
  label: 'US$37',
  original: 'US$74',
  note: 'One-time payment. Digital PDF collection.',
} as const
